enum ErrorPageType {
  DEFAULT = '500',
  NOT_SUPPORTED = 'not-supported',
}

export default ErrorPageType;
